import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RecordService {

  private readonly prefixConfigCompany: string = "/company/configuration";

  constructor(private readonly http: HttpClient) {}

  /*public async getListValidatorsByCompany(idCompany: number) {
    const url = `${this.prefixConfigCompany}/${idCompany}`;
    const response: any = await this.http.get(url).toPromise();
    return response;
  }*/

  /**
   * Get configuration of type transaction by idCompany and idTransaction
   * @param idCompany ID of the company
   * @param idTransaction ID of the transaction
   * @returns the list of configurations of the transaction
   */
  public async getListValidatorsByCompanyAndTransaction(idCompany: number, idTransaction: string) {
    const url = `${this.prefixConfigCompany}/transaction/${idCompany}?transactionId=${idTransaction}`;
    const response: any = await this.http.get(url).toPromise();
    return response;
  }

  /**
   * Get configuration of type transaction by idCompany, idTransaction and idParent (Android, IOS, Web, etc).
   * @param idCompany ID of the company
   * @param idTransaction ID of the transaction
   * @param sectionParent ID of the section parent (Android, IOS, Web, etc)
   * @returns the list of configurations of the transaction
   */
  public async getConfigCompTransParent(idCompany: string, idTransaction: string, idSectionParent: string) {
    const url = `${this.prefixConfigCompany}/all/${idCompany}?transactionId=${idTransaction}&sectionParent=${idSectionParent}`;
    const response: any = await this.http.get(url).toPromise();
    return response;
  }


}
